

var util = {

    
    /***
     * debounce
     *
     */
    debounce: function(fn, delay, scope) {

        var timer = null;
        return function() {
            var context = (scope) ? scope: this,
                args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(context, args);
            }, delay);
        };

    },


    /***
     * determine if an element is in view
     *
     */
    elemIsInView: function(elem, elemHeightOverride) {
        var inView = false;

        var winScrollTop   = window.pageYOffset;
        var winHeight      = window.innerHeight;

        // viewport values (relative to the scroll)
        var viewportTop    = winScrollTop;
        var viewportBottom = winScrollTop + winHeight;

        var elemRect = elem.getBoundingClientRect();

        // element's top and bottom positions relative to the document
        var elemHeight     = elem.offsetHeight;
        var elemTop        = elemRect.top + winScrollTop;
        var elemBottom     = elemTop + elemHeight;

        var elemDisplay = elem.style.display;
        var elemVisibility = elem.style.visibility;

        var isVisible = elemDisplay !== 'none' && elemVisibility !== 'hidden';

        var heightCheck = (elemHeightOverride) ? elemHeightOverride : 0.35;

        // adding/subtracting a fraction of the elem height
        // is a way to move the top line downwards, and moving the bottom line upwards
        if (isVisible && elemTop + (elemHeight * heightCheck) < viewportBottom && elemBottom - (elemHeight * heightCheck) > viewportTop) {
            inView = true;
        }

        return inView;
    },


    /***
     * ensure console methods fail silently on incompatible browsers
     *
     */
    safeConsole: function() {
        var i, method;
        var methods = [
            'log',
            'time',
            'table',
            'warn'
        ];

        var emptyFn = function() {
            return;
        };

        if (!window.console) {
            window.console = {};
        }

        for (i = 0; i < methods.length; i++) {
            method = methods[i];

            if (!window.console[method]) {
                window.console[method] = emptyFn;
            }
        }
    },


    /***
     * capitalise first letter of a string
     *
     */
    capitaliseFirstLetter: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },


    /***
     * polyfill native bind method
     *
     */
    bindPolyfill: function() {
        if (!Function.prototype.bind) {
            Function.prototype.bind = function(oThis) {
                if (typeof this !== "function") {
                    // closest thing possible to the ECMAScript 5
                    // internal IsCallable function
                    throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
                }

                var aArgs = Array.prototype.slice.call(arguments, 1),
                    fToBind = this,
                    fNOP = function() {},
                    fBound = function() {
                        return fToBind.apply(this instanceof fNOP && oThis ? this : oThis,
                            aArgs.concat(Array.prototype.slice.call(arguments)));
                    };

                fNOP.prototype = this.prototype;
                fBound.prototype = new fNOP();

                return fBound;
            };
        }

    },



    /***
     * safely use requestAnimationFrame 
     *
     */
    requestAnimationFramePolyfill: function() {
        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
        }

        if (!window.requestAnimationFrame)
            window.requestAnimationFrame = function(callback, element) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
                                           timeToCall);
                                           lastTime = currTime + timeToCall;
                                           return id;
            };

            if (!window.cancelAnimationFrame)
                window.cancelAnimationFrame = function(id) {
                    clearTimeout(id);
                };
    }

};

module.exports = util;




/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/src/utilities/helpers.js
 ** module id = 5
 ** module chunks = 0
 **/